import React, { Fragment, useState, useEffect, useRef } from "react";
import {
  Table,
  Button,
  Card,
  CardTitle,
  Row,
  Col,
  FormGroup,
  Input,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Dropdown,
  InputGroup, InputGroupText,
} from "reactstrap";
import { VIEW_CUSTOMER_PATH } from "../../utils/AppRoutes";
import { Link } from "react-router-dom";
import { CUSTOMERLIST_URL } from "../../utils/APIEndpoints";
import { authHeader } from "../../utils/functions/CoreFunctions";
import API from "../../redux/actions/API";
import {
  SingleStringFirstLetterCaps,
  getCurrentAgencyId,
  getAlertToast,
} from "../../utils/functions/CustomFunctions";
import CustomTableLoader from "../common/CustomTableLoader";
import CustomTableEmptyRecord from "../common/CustomTableEmptyRecord";
import CustomTableHeader from "../common/CustomTableHeader";
import Pagination from "../common/Pagination";
import { debounce } from "underscore";
import Swal from "sweetalert2";
import generatePDF from "./CustomerReport";
import { CSVLink } from "react-csv";
//Table Columns
const tableColumns = [
  { title: "Email" },
  { title: "First Name" },
  { title: "Last Name" },
  { title: "Phone Number" },
  { title: "Total Requests" },
];

const Customers = (props) => {
  //State
  const [currentPage, setCurrentPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [gridData, setGridData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    count: 10,
  });
  const [dropdownOpen, setdropdownOpen] = useState(false);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const filterToggle = () => {
    setIsFilterOpen(!isFilterOpen);
  };
  const toggle = () => {
    setdropdownOpen(!dropdownOpen);
  };

  useEffect(() => {
    delayedQuery(filter);
  }, [filter]);

  // useEffect(() => {
  //   getGridData({
  //     ...filter,
  //     // count: rowsPerPage || undefined,
  //     offset: currentPage,
  //     agencyId: parseInt(getCurrentAgencyId()),
  //   });
  // }, [rowsPerPage]);

  //Debounce
  const delayedQuery = useRef(
    debounce(
      (filter) =>
        getGridData({
          ...filter,
          // count: rowsPerPage || undefined,
          offset: currentPage,
          agencyId: parseInt(getCurrentAgencyId()),
        }),
      500
    )
  ).current;

  //Onchange filter
  const changeFilterField = ({ target: { name, value } }) => {
    setFilter((val) => ({ ...val, [name]: value }));
  };

  const handleReset = () => {
    setFilter((val) => ({
      ...val,
      firstName: "",
      lastName: "",
      email: "",
      phoneNumber: "",
    }));
  };

  const onPageChanged = (page) => {
    setCurrentPage(page - 1);
    getGridData({
      ...filter,
      offset: page - 1,
      agencyId: parseInt(getCurrentAgencyId()),
    });
  };

  const rowperpageHandel = (e) => {
    const { value, name } = e.target;
    setCurrentPage(0);
    setFilter((val) => ({ ...val, [name]: value || undefined }));
  };
  //Get Grid Data
  const getGridData = async (queryParams) => {
    try {
      setLoading(true);
      const options = {
        method: "GET",
        url: CUSTOMERLIST_URL,
        headers: authHeader(),
        params: {
          ...queryParams,
        },
      };
      const response = await API(options);
      const { status, data: initialResponse = [], totalCount } = response.data;
      if (status === "Success") {
        setTotalRecords(totalCount);
        let dataToDis = initialResponse.map((record) => {
          let { firstName, lastName } = record;
          let formattedData = {
            firstName: SingleStringFirstLetterCaps(firstName),
            lastName: SingleStringFirstLetterCaps(lastName),
          };
          let dataToReturn = { ...record, ...formattedData };
          return dataToReturn;
        });
        setGridData(dataToDis);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      setLoading(false);
    }
  };

  let Export = () => {
    generatePDF(gridData);
  };

  const headers = [
    { label: "Email", key: "email" },
    { label: "First Name", key: "firstName" },
    { label: "Last Name", key: "lastName" },
    { label: "Phone Number", key: "phoneNumber" },
    { label: "Total Requests", key: "requestCount" },
  ];

  const { firstName, lastName, email, phoneNumber } = filter;
  return (
    <Fragment>
      <Card body className="mt-5">
        <div className="mb-4 tableTitleBg ">
          <CardTitle className=" " style={{ margin: "0" }}>
            Customers
          </CardTitle>
          <div className="top-btn">
            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
              <DropdownToggle color="danger" caret>
                Export
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={Export}>PDF</DropdownItem>
                <DropdownItem>
                  <CSVLink
                   className="link"
                    filename={"Customers_report.csv"}
                    data={gridData}
                    headers={headers}
                  >
                    CSV
                  </CSVLink>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <i
            className="fas fa-filter"
            style={{
              float: "right",
              margin: "0px 7px 3px 16px",
              fontSize: "19px",
              cursor: "pointer",
            }}
            onClick={filterToggle}
          ></i>
        </div>
        {isFilterOpen && (
          <Row form className="mb-4">
            <Col md={3}>
              <FormGroup>
                <Input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  onChange={changeFilterField}
                  value={firstName}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  onChange={changeFilterField}
                  value={lastName}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Input
                  type="text"
                  name="email"
                  placeholder="Email"
                  onChange={changeFilterField}
                  value={email}
                />
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <InputGroup>
                  
                    <InputGroupText>+1</InputGroupText>
                  
                  <Input
                    type="text"
                    name="phoneNumber"
                    placeholder="Phone Number"
                    onChange={changeFilterField}
                    value={phoneNumber}
                  />
                </InputGroup>
              </FormGroup>
            </Col>
            <Col md={2}>
              <div style={{ marginTop: "4px" }}>
                <Button color="danger" onClick={handleReset}>
                  Reset
                </Button>
              </div>
            </Col>
          </Row>
        )}
        <Table responsive hover>
          {/* Table Header */}
          <CustomTableHeader tableColumns={tableColumns} />
          {/* Table Header */}
          <tbody>
            {loading ? (
              // Table Loader
              <CustomTableLoader columnsCount={tableColumns.length} />
            ) : (
              // Table Loader
              <Fragment>
                {!gridData.length ? (
                  //  Empty Record
                  <CustomTableEmptyRecord columnsCount={tableColumns.length} />
                ) : (
                  //  Empty Record
                  <Fragment>
                    {gridData.map((record, key) => (
                      <tr key={`record_key_${key}`}>
                        <td>
                          <Link className="link" to={VIEW_CUSTOMER_PATH + "/" + record.email}>
                            {record.email}
                          </Link>
                        </td>
                        <td>{record.firstName}</td>
                        <td>{record.lastName}</td>
                        <td>(+1) {record.phoneNumber}</td>
                        <td>{record.requestCount}</td>
                      </tr>
                    ))}
                  </Fragment>
                )}
              </Fragment>
            )}
          </tbody>
        </Table>
        {gridData.length ? (
          <div className="d-flex py-4 justify-content-end space_between">
            <div className="space_between">
              <div>
                <p className="per_page">Records/Page</p>
              </div>
              <div>
                <FormGroup>
                  <Input
                    className="pagi_drop"
                    type="select"
                    name="count"
                    onChange={rowperpageHandel}
                    value={filter.count}
                  >
                    <option value={""}>Show All</option>
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Input>
                </FormGroup>
              </div>
            </div>
            {filter.count && (
              <div>
                <Pagination
                  itemClass="page-item"
                  linkClass="page-link"
                  activePage={currentPage + 1}
                  itemsCountPerPage={filter.count}
                  totalItemsCount={totalRecords}
                  onChange={onPageChanged}
                />
              </div>
            )}
          </div>
        ) : (
          ""
        )}
      </Card>
    </Fragment>
  );
};

export default Customers;

